import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { useI18n } from 'vue-i18n'
import { toast } from 'vue-sonner'
import { markNotificationRead } from '@/features/notifications/api/mark-notification-read'
import { NOTIFICATIONS_QUERY_KEY } from '@/features/notifications/queries/keys'
import type { ApiError } from '@/lib/api/errors'

export function useMarkNotificationRead() {
  const queryClient = useQueryClient()
  const { t } = useI18n()

  return useMutation({
    mutationFn: markNotificationRead,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: NOTIFICATIONS_QUERY_KEY }),
    onError: (error: unknown) => {
      toast.error((error as ApiError).message || t('notifications.toast.markReadFailed'))
    },
  })
}
